import Table from 'react-bootstrap/Table';

const POIQueryResultTable = ({poiResult}) => {
    return (
        <>
            <small><em>Innerhalb der maximalen Abfragedistanz <br/> (Nur für das Gebiet des Landes Salzburg)</em></small>
            <Table striped bordered hover size="sm">
                <thead>
                <tr>
                    <th className="text-right">Kategorie</th>
                    <th className="text-right">Abgedeckt?</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="text-right">Schule</td>
                    <td className="text-right">{poiResult.school ? <span className="check">&#10003;</span> :
                        <span className="cross">&#10007;</span>}</td>
                </tr>
                <tr>
                    <td className="text-right">Lebensmittel Nahversorgung</td>
                    <td className="text-right">{poiResult.lebensmittel ? <span className="check">&#10003;</span> :
                        <span className="cross">&#10007;</span>}</td>
                </tr>
                </tbody>
            </Table>
        </>
    )
}

export default POIQueryResultTable;
